<template>
	<BaseCmsPage v-slot="{page}">
		<BaseAuthUser v-slot="{user}">
			<CmsIntroContainer :page="page" mode="auth">
				<template #h1>
					<h1 class="a-dashboard-title">
						<BaseCmsLabel code="welcome" default="Pozdrav" /> <template v-if="user?.first_name"> {{user.first_name}}</template>
					</h1>
				</template>
			</CmsIntroContainer>
			<AuthMainLayout>
				<template #authContent>
					<ClientOnly>
		 				<BaseCatalogWishlist v-slot="{items, onRemove}">
							<div class="a-wishlist-header">
								<div class="wishlist-title">
									<BaseCmsLabel code="my_wishlist" /> <span v-if="items?.length > 0" class="a-wishlist-counter active">(<span class="wishlist_count">{{items?.length}}</span>)</span>
								</div>
								<div v-if="items?.length > 0" @click="onRemove" class="wishlist-btn-delete">
									<span><BaseCmsLabel code="delete_wishlist" /></span>
								</div>
							</div>

							<div v-if="items?.length > 0" class="wishlist-detail-items a-wishlist-detail-items" id="view_wishlist">
								<template v-for="item in items" :key="item.id">
									<CatalogIndexEntry :item="item" mode="wishlist" list="wishlist" />
								</template>
							</div>
							<div v-else class="auth-no-content" id="empty_wishlist">
								<BaseCmsLabel code="wishlist_no_products" />
							</div>
						</BaseCatalogWishlist>
					</ClientOnly>
				</template>
			</AuthMainLayout>
		</BaseAuthUser>
	</BaseCmsPage>
</template>

<script setup>
</script>

<style lang="less" scoped>
</style>